import { TmBaseError } from '@/core/error/tmBaseError'

export class TmBillingProviderError extends TmBaseError {
  public name = 'TmBillingProviderError'
}
